// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"31b71293","618":"8df6ae4f","891":"03c281d2"}[chunkId] + ".chunk.js";
};